import React, { Component } from "react"
import { connect } from 'react-redux'
import {
    saveTransactionAction
} from '../../redux/actions/MainAction'
import moment from 'moment'
import {msg} from '../Notifications/MsgBox';
import { Input, DatePicker, InputDecimal,InputNumber, Information } from "../core"
import validateUtil from '../../helpers/validateUtil'
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction,
    clearModalAction
} from '../../redux/actions/ModalEmployeeAction'

import { UploadButton, UploadList,HeaderTable,UploadLisNoHead ,UploadRadio,DocumentNotApproveModal,PanelNotApprove} from "../../components"
import utilityHelper from '../../helpers/helperUtil'
import { Storage, MessageText } from '../../configs'
import PanelFineMom from '../PanelFineMom';
import PanelProductEdit from '../PanelProductEdit'
import {
    updateMR_DetailAction,
} from '../../redux/actions/MRAction'
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction"
import { getFileAction,deleteFileAction } from '../../redux/actions/UploadAction'
import {ACollapse,CollapseDetail} from '../../components'
import TextOrInput from "../TextOrInput";

import SinglePagePDFViewer from "../../components/pdf/single-pages";
import AllPagesPDFViewer from "../../components/pdf/all-pages";
import { data_t_MR_ATTACHMENTS } from "../../configs/datas";
import POHistory from '../../components/POHistory';
import Button from "@material-ui/core/Button";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { ParcelReceiptTemplate,Data } from "./Template";
import CustomDialog from '../../components/Notifications/Dialog';
import MomDetailDeleteMOM from '../../components/MomDetail/MomDetailDeleteMOM';
import MomDetailDeleteMOMView from '../../components/MomDetail/MomDetailDeleteMOMView';
import AdjustmentService from '../../services/AdjustmentService'
import ContractMomService from '../../services/ContractMomService'
import { getSearchDirectoryInfoAction} from '../../redux/actions/MasterAction'
import { Label } from "@material-ui/icons";
import { Typography } from "@material-ui/core";
import { async } from "regenerator-runtime";
import './style.css'
import $ from "jquery";
import UserServices from '../../services/UserServices';
// import ReactQuill, { Quill, Mixin, Toolbar } from 'react-quill'; // ES6
// import 'react-quill/dist/quill.snow.css'; // ES6
class MomDetail extends Component {

    constructor() {
        super()

        this.state = {
            local_t_PO_DETAIL: {},
            local_t_MR_ATTACHMENT:[],
            overall_limit: 0,
            ol_currency: "THB",
            expected_value: 0,
            ev_currency: "THB",
            actual_value: 0,
            av_currency: "THB",
            total_received_value: 0.00,
            trv_currency: "THB",
            serviceItemNo: "",
            purchase_checkall: false,
            service_checkall: false,
            serviceline_checkall: false,
            transaction_no: "",
            po_contract_no: "",
            viewMode: false,
            showApproveOrder: false,
        textAreaValue:"",
        openPOHistory:false,
        hasPrintHeader:true,
        objPrint:{},
        draw: 0,
        draw_html: 0,
        complete_date_by_po: [],
        complete_date_notcheck_po_date: [],
        openDeleteDialog: false,
        appReadonly: true
        }
        this.handlePoChange = this.handlePoChange.bind(this)
        //this.handlerSearchPO=this.handlerSearchPO.bind(this)
        this.getDocName = this.getDocName.bind(this)
        this.getDocNameForm = this.getDocNameForm.bind(this)
        this.handleCollapse = this.handleCollapse.bind(this)
        this.handleCangeApprove = this.handleCangeApprove.bind(this)
        this.handleCangeComment = this.handleCangeComment.bind(this)
        this.onDeleteComplete = this.onDeleteComplete.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeByName = this.handleChangeByName.bind(this)
        this.handleMrRefChange = this.handleMrRefChange.bind(this)
        this.searchEmployeeModal = this.searchEmployeeModal.bind(this)
        this.handleChangeQuill = this.handleChangeQuill.bind(this)
        this.editChange = this.editChange.bind(this)
        this.openUploadModal = this.openUploadModal.bind(this)
        this.closeModel = this.closeModel.bind(this)
        this.onUploadComplete = this.onUploadComplete.bind(this)
        this.onUploadCancel = this.onUploadCancel.bind(this)
        this.onUploadFileComplete = this.onUploadFileComplete.bind(this)
        this.onChangeSelectedFile = this.onChangeSelectedFile.bind(this)
        //this.onDeleteComplete = this.onDeleteComplete(this)
        window.onChangeTab = this.onChangeTab.bind(this)
        this.handleShowCompleteDateAll();
        this.handleApplicationCheckReadonly()
        
        

    }

    getTransNo(){
        let result;
        let {transaction_no} = this.state;
        let {temp_trans_att_no} = this.props;
        result= transaction_no;
        if(transaction_no == "" || transaction_no == null || transaction_no == undefined)
            result=temp_trans_att_no;

        return result;
    }

    manualChangeState()
    {
        let {changeMomHtmlInitial} = this.state;
        if(changeMomHtmlInitial !== 'initial')
        {
            setTimeout(()=>{
                this.setState({changeMomHtmlInitial:'initial'})
            }, 300)

            AdjustmentService.searchReportAction()
        }
    }

    editChange(text, isEditHtml)
    {
        if(isEditHtml)
        {
            let {t_MR_DETAIL} = this.props
            //console.log('editChange text',t_MR_DETAIL.mom_html);
            t_MR_DETAIL.mom_html = text;
    
            this.props.updateMR_Detail(text, 'mom_html')
    
            //console.log('editChange text',t_MR_DETAIL.mom_html);
        }
    }

    closeModel(modalId)
    {
    }

     async handleApplicationCheckReadonly()
        {
            UserServices.ApplicationReadonly().then(response=>{
                if(response.data === false)
                {
                    this.setState({appReadonly: false})
                }
            })
        }

    onChangeSelectedFile = (file, file_type) => {

    }

    onUploadComplete =  (modalId) => {
        const {t_MR_DETAIL} = this.props
        let index = 0
        if (modalId.substring(0,modalId.length-1) === "attachedDocumentNotAppModal")
        {
             index = modalId.substring(modalId.length-1) - 1 ;   
             const {t_PO_COMMITTEE,transaction_no,t_MR_DETAIL} = this.props  
             this.props.getFile(this.getTransNo())    
            t_PO_COMMITTEE[index].approve_status = "N";
            this.setState({
            ["approve_status"+index]: "N"
            })
            if (t_MR_DETAIL.approver_code && t_MR_DETAIL.approver_code !== ""){
                this.props.getSearchDirectoryInfo(t_MR_DETAIL.approver_code, '', '', '' ,'', '', '', '', 0, 5 ).then((response) => {
                    if (response.data != null && response.data.length > 0) {
                        let item = response.data[0]
                        this.props.updateMR_Detail(item.employeeId, "approve_order_code");
                        this.props.updateMR_Detail(item.iname + " " + item.employeeNameTH, "approve_order_name");
                        this.props.updateMR_Detail(item.positionNameTH , "approve_order_position");
                        this.props.updateMR_Detail(item.mobileNo , "approve_order_telephone");
                        this.props.updateMR_Detail(item.eMailAddress , "approve_order_email");
                    }
            
        
                    // if (!response.data) {
                    //     msg.error("ไม่พบข้อมูล")
                    //     return
                    // }
                })
            }
        }
    }
    onUploadCancel =  (modalId) => {    
        const {t_PO_COMMITTEE,upload_files,transaction_no} = this.props  
        let index = 0
        if (modalId.substring(0,modalId.length-1) === "attachedDocumentNotAppModal")
        {
             index = modalId.substring(modalId.length-1) - 1 ;   
            this.props.getFile(this.getTransNo());         
            let countFile = upload_files.filter(w => w.file_category === ('A' +(index+1))).length 
            if ( countFile > 0){
                t_PO_COMMITTEE[index].approve_status = "N";
                this.setState({
                ["approve_status"+index]: "N"
                })
                }

        }
    }

    openUploadModal(key) {
        const { modalId,transaction_no,file_category,defaultFileName } = this.props;
        // key = key + 1       
        // if(transaction_no !== "")
        // {
        //     window.$(`#filename_A`+key).val("รายงานความเห็นแย้ง" + key);
        //     window.$(`#file_A`+key).val('');
        //     window.$(`#attachedDocumentNotAppModal`+key).modal('show');
        // }
        // else{
        //     msg.error("กรุณาบันทึกรายการก่อน อัพโหลดไฟล์")
        // }

    }

    onChangeTab(tabid) {
        if (tabid === "mo") {
            let { local_t_GR_DETAIL, local_t_GR_ITEM, local_t_GR_SERVICE, local_t_MR_IR_DESCRIPTION } = this.state
            const { t_GR_DETAIL, t_GR_ITEM, t_GR_SERVICE, transaction, viewMode, transaction_no, t_MR_IR_DESCRIPTION } = this.props
            //local_t_MR_IR_DESCRIPTION = this.bindingMrIrDesCroption(t_GR_ITEM, t_GR_SERVICE, local_t_MR_IR_DESCRIPTION, transaction_no, t_GR_DETAIL, t_MR_IR_DESCRIPTION)
            //this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTION, "", "", true)
            local_t_GR_SERVICE = t_GR_SERVICE
            this.setState({
                transaction_no: transaction_no,
                viewMode: viewMode,
                //delivery_note: t_GR_DETAIL.delivery_note,
                //document_date: t_GR_DETAIL.document_date ? moment(t_GR_DETAIL.document_date).format('DD/MM/YYYY') : null,
                //post_date: t_GR_DETAIL.post_date ? moment(t_GR_DETAIL.post_date).format('DD/MM/YYYY') : null,
                //local_t_GR_DETAIL: t_GR_DETAIL,
                //local_t_GR_ITEM: t_GR_ITEM,
                //local_t_GR_SERVICE: local_t_GR_SERVICE,
                //local_t_MR_IR_DESCRIPTION: local_t_MR_IR_DESCRIPTIONS
                //...this.state.local_t_MR_IR_DESCRIPTION,
                // local_t_MR_IR_DESCRIPTION: local_t_MR_IR_DESCRIPTION.map((data, i) => {
                //     return data
                // })
            })
        }
    }
    componentDidMount(){
        let {local_t_MR_ATTACHMENT,temp_transaction_no} = this.state

        local_t_MR_ATTACHMENT = this.props.t_MR_ATTACHMENTS

        this.setState({local_t_MR_ATTACHMENT:local_t_MR_ATTACHMENT,temp_transaction_no})
    }
    componentWillReceiveProps(nextProps) { 

        //alert ("this.state.transaction_no ==>" + this.state.transaction_no  + " nextProps.transaction_no ==> " + nextProps.transaction_no)
        let { local_t_MR_ATTACHMENT } = this.state
        //if (local_t_MR_ATTACHMENT && nextProps.local_t_MR_ATTACHMENT && local_t_MR_ATTACHMENT.length === 0 && nextProps.t_MR_ATTACHMENTS.length > 0 && local_t_MR_ATTACHMENT !== nextProps.t_MR_ATTACHMENTS) {

            this.setState({
                //transaction_no: transaction_no,
                viewMode: nextProps.viewMode,
                // delivery_note: nextProps.t_GR_DETAIL.delivery_note,
                // document_date: nextProps.t_GR_DETAIL.document_date ? moment(nextProps.t_GR_DETAIL.document_date).format('DD/MM/YYYY') : null,
                // post_date: nextProps.t_GR_DETAIL.post_date ? moment(nextProps.t_GR_DETAIL.post_date).format('DD/MM/YYYY') : null,
                // local_t_GR_DETAIL: nextProps.t_GR_DETAIL,
                // local_t_GR_ITEM: nextProps.t_GR_ITEM,
                // local_t_GR_SERVICE: nextProps.t_GR_SERVICE,
                // ...this.state.local_t_MR_IR_DESCRIPTION,
                local_t_MR_ATTACHMENT: nextProps.t_MR_ATTACHMENTS
            })

        //}
        if (this.state.transaction_no !== nextProps.transaction_no) {

            if (nextProps.transaction_no) {
                this.props.getFile(nextProps.transaction_no).then((res) => {

                    this.setState({
                        transaction_no: nextProps.transaction_no
                    })
                });

            } else {
                console.log("nextProps.transaction_no is null!")
            }

        }
        // var cref_no = this.state.ref_no == null ? '' : this.state.ref_no
        // var nref_no = nextProps.t_MR_DETAIL.ref_no == null ? '' : nextProps.t_MR_DETAIL.ref_no
         var nviewMode = false;
        // if (cref_no !== nref_no) {
        //     if (nref_no !== "") {
        //         this.setState({
        //             viewMode: true
        //         })
        //         nviewMode = true;
        //     }
        //     else {
        //         this.setState({
        //             viewMode: false
        //         })
        //         nviewMode = false;
        //     }
        // }

        //check viewmode จาก redux
        if (this.state.viewMode !== nextProps.viewMode) {
            if (nextProps.viewMode !== null && nextProps.viewMode !== "") {
                this.setState({
                    viewMode: nextProps.viewMode || nviewMode
                })
            }
            else {
                this.setState({
                    viewMode: false
                })
            }
        }

    }
   

    handleCollapse() {
        window.$('#collapseItemOverview').toggleClass('show');
        window.$('#collapseItemOverview').focus();

    }

    getStatus(status_code) {
        const result = this.props.status_data.filter((data) => {
            return data.code == status_code
        })
        return result[0] ? result[0].description : ""
    }

    handlePoChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    // handlerSearchPO(){
    //     if(this.props.onSearchPO){
    //         if(!this.state.po_contract_no){
    //             msg.error("กรุณากรอกข้อมูล Purchase / Contract Number");
    //             return;
    //         }
    //         this.props.onSearchPO(this.state.po_contract_no)
    //     }     
    // }

    getDocName(docName) {
        let docNameNew = docName
        if (docName && docName.indexOf("#!#") >= 0) {
            docNameNew = docName.split("#!#").map((item, index) => {
                if (index == docName.split("#!#").length) {
                    return <span key={index}>{item}</span>
                } else {
                    return <React.Fragment key={index}><span>{item}</span><br /></React.Fragment>
                }

            });
        }

        return docNameNew
    }

    getDocNameForm(docName) {
        let docNameNew = docName
        let docNameReturn = docName ? docName.split("#!#").join(" ") : ""
 

        return docNameReturn
    }

    async openConfirmModal(event) {  

        const {
            t_PO_DETAIL,
            t_HEADER
        } = this.props
        const role = Storage.getRole()
        this.props.updateMR_Detail(this.handleCheckCompleteDateMode(t_PO_DETAIL.po_contract_no,t_HEADER.product_type), 'ignore_complete_date_mode')

        await this.props.startLoading()
        //await this.props.onConfirmModalMethod(event);
        //await this.props.onConfirmVerifyMoalMethod(event);
        if (role==="C"){
            await this.props.onConfirmModalMethod(event);
            }
            else {
            await this.props.onConfirmVerifyMoalMethod(event);
            }

    }

    handleCangeApprove(event ,key){
        const {t_PO_COMMITTEE,upload_files,transaction_no} = this.props       
        const { name, value } = event.target          
        const user = Storage.getUser()
        this.props.getFile(this.getTransNo()); 
        let lstFile = upload_files.filter(w => w.file_category === ('A' +(key+1)))
        let lstFileNA = upload_files.filter(w => w.file_category === ('NA'))
        let countFile = lstFile.length 

        if (value==='N')
        {    

           if ( countFile > 0){
                this.setState({
                    [name]: value
                })
            }
        }
        else {
            t_PO_COMMITTEE[key].approve_status = value;
            t_PO_COMMITTEE[key].comment = '';
            this.setState({
                [name]: value,
                ["comment_" + key]: ''
            })
            let trans_no =""
            
            lstFile.forEach(item => {
            this.props.deleteFile(item.transaction_no, item.running, user.userName)
                    .then(response => {
                        this.props.getFile(this.getTransNo()) 
                    })             
            });
            
            if (t_PO_COMMITTEE.filter(w => w.approve_status === ('N' )).length == 0) {
                lstFileNA.forEach(item => {
                    this.props.deleteFile(item.transaction_no, item.running, user.userName)
                            .then(response => {
                                this.props.getFile(this.getTransNo()) 
                            })             
                    });
            }     
        }
        const countNotApprove = t_PO_COMMITTEE.filter(w => w.approve_status === 'N') 
        let isShow = countNotApprove > 0
        this.setState({
            [name]: value,
            ["showApproveOrder"]:isShow,
        })
    }

    onUploadFileComplete(event ,key){
        const {t_PO_COMMITTEE} = this.props       
        const { name, value } = event.target   

        t_PO_COMMITTEE[key].approve_status = value;

        const countNotApprove = t_PO_COMMITTEE.filter(w => w.approve_status === 'N') 
        let isShow = countNotApprove > 0
        this.setState({
            [name]: value,
            ["showApproveOrder"]:isShow,
        })

    }

    handleCangeComment(event ,key){
        const {t_PO_COMMITTEE} = this.props       
        const { name, value } = event.target   
        t_PO_COMMITTEE[key].comment = value;
        this.setState({
            [name]: value
        })
    }
    
    onDeleteComplete(event ,key){
        const {t_PO_COMMITTEE,upload_files,transaction_no} = this.props       
        let countFile = upload_files.filter(w => w.file_category === ('A' +(key+1))).length  
        if ( countFile <= 1){
            //t_PO_COMMITTEE[key].approve_status = "Y"
            t_PO_COMMITTEE[key].comment = ""
            this.setState({
                //["approve_status"+ key]: 'Y',
                ["comment_"+key]: ''
            })
        }
    }
    toBoolean(value) {
        if (value === 1)
            return true
        else if (value === true)
            return true
        else
            return false
    }

    searchEmployeeModal(empCode, empName) {
        console.log("openSearch");

        this.props.clearSearchDirectoryInfo();
        this.props.clearModal();

        this.props.setKeyValue('T_MR_DETAIL', empCode, empName)
        window.$('#searchEmployeeModal').modal('show');

    }

    formatDisplayEmployee(empCode, empName) {
        if (empCode !== null && empCode !== '')
            return `${empName} (${empCode})`
        else
            return ''

    }

    formatDisplayEmployeeApprover(empCode, empName) {
        const {
            t_MR_DETAIL,
            t_PO_COMMITTEE,
        } = this.props

        if (empCode !== null && empCode !== ''){

            let listError = []
            validateUtil.addListError(listError
                ,'T_MR_DETAIL'
                ,validateUtil.checkCommiteeWithApprover(t_MR_DETAIL,t_PO_COMMITTEE)
            )
         
            if (Object.keys(listError).length > 0) {
                msg.warningSave(listError);
                this.props.updateMR_Detail('', 'approver_code');
                this.props.updateMR_Detail('', 'approver_name');

               
                return ''
            } 

            return `${empName} (${empCode})`
        }
        else
            return ''

    }

    handleMrRefChange(event) {

        this.handleChange(event)
    }

    handleChange(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? true : false) : target.value;
        const name = target.name;
        if (name === "invoic_description") {
            let { local_t_MR_IR_DESCRIPTION } = this.state
            if (valid) {
                this.setState({
                    invoicDescription: value,
                    ...this.state.local_t_MR_IR_DESCRIPTION,
                    local_t_MR_IR_DESCRIPTION: local_t_MR_IR_DESCRIPTION.map((data, i) => {
                        if (index === i) {
                            let updateItem = data
                            updateItem[name] = value
                            return updateItem
                        } else {
                            return data
                        }
                    })
                });

                //this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTION, "", "", true)
            }

        } 
        else if(name==="comment"){
            
        }
        else {
            //check date
            if (target.className.indexOf("js-datepicker") > -1 && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                       if (name === "po_approve_date") this.props.t_PO_DETAIL.po_approve_date = value
                    }
                }

            }

            if (name === "ref_no") {
                let { transaction_no } = this.props  
                this.props.getMrRefData(value, transaction_no)
                this.props.getMrRefDataVendor(value, transaction_no)
                this.props.getFile(value)
                if (value != "") {
                    this.setState({
                        viewMode: true,

                    })
                }
                else {
                    this.setState({
                        viewMode: false,

                    })

                }

            }
            if (valid) {
                if (name !== "po_approve_date"){
                this.props.updateMR_Detail(value, name)
                }
            } else {
                return
            }
        }

        if(name === 'completed_date')
        {
            this.handleChangeAuditCommitteeTimeToConsiderDate(value)
        }

    }

    handleDateDiffNow = (date) =>{
        let now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return moment(now).diff(date, 'days')
    }

    handleChangeByName(value, name) {
        this.props.updateMR_Detail(value, name)
    }

    async handleChangeVendor(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (valid) {
            this.props.updateMR_Vendor(value, index, name)
        } else {
            return
        }
    }
    async handleChangeAttachment(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (valid) {
            this.props.updateMR_Attachment(value, index, name)
        } else {
            return
        }
    }

    async handleSubmit(event, source,submit,status, nexttab ) {

        const {
            t_PO_DETAIL,
            t_HEADER
        } = this.props

        this.props.updateMR_Detail(this.handleCheckCompleteDateMode(t_PO_DETAIL.po_contract_no, t_HEADER.product_type), 'ignore_complete_date_mode')

        await this.props.startLoading()
        let checkErrors = []
        let error_messages = []

        if (checkErrors.length > 0) {
            checkErrors.forEach((error) => {
                error_messages.push(error.error_message)
            })
            msg.error(error_messages.join('<br/>'))
            this.props.stopLoading()
        }
        else {
            //await this.props.onHandleSubmit(event, source, null, null);
            await this.props.onHandleSubmit(event, source, submit, status, nexttab);

            setTimeout(()=>{
                this.setState({draw:this.state.draw+1});
            },5000)
           
        }
    }
    handleChangeQuill(value) {
        var text = 
        
        this.setState({ text: value })
      }

      openRejectModal() {
        window.$('#RejectWithOptionModal').modal('show');

    }


    handleOnClosePOHistory(){
        this.setState({
            openPOHistory: false
        })
    }

    handleOnClosePrintFile(){
        this.setState({
            openPrintFile: false
        })
    }

    handleOnOpenPrintFile(){
        this.setState({
            openPrintFile: true
        })
    }

    handleOnOpenDeleteDialog(transaction_no){
        
        ContractMomService.checkCanDeleleMom(transaction_no).then(res=>{
            if(res.success)
            {
                if(res.data)
                {
                    this.setState({
                        openDeleteDialog: true
                    })
                }else{
                    msg.warning("กรุณาดำเนินการผ่านระบบ MR เนื่องจากมีการสร้างใบตรวจรับเรียบร้อยแล้ว")
                }
            }else{
                msg.warning(res.message)
            }
        })
    }

    handleOnCloseDeleteDialog(){

        console.log('handleOnCloseDeleteDialog')

        this.setState({
            openDeleteDialog: false
        })
    }

    handleOnOpenPOHistory(){
        this.setState({
            openPOHistory: true
        })
    }

    setHasPrintHeader(v){
        this.setState({
            hasPrintHeader: v
        })
    }

    toDateStringThai(txt)
    {  
        if(typeof txt.getMonth === 'function')
        {
            const result = txt.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
      
              return result;
        }
        else if(txt.substr(4,1) === '-')
        {
            const txts = txt.split('-');
            const date = new Date(parseInt(txts[0]), parseInt(txts[1]) - 1, parseInt(txts[2]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
    
            return result;
        }
        else if(txt && txt.length === 10)
        {
            const txts = txt.split('/');
            const date = new Date(parseInt(txts[2]), parseInt(txts[1]) - 1, parseInt(txts[0]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
    
            return result;
        }else if(txt && txt.length === 19)
        {
            const txtTs = txt.split('T');
            const txts = txtTs[0].split('-');
            const date = new Date(parseInt(txts[0]), parseInt(txts[1]) - 1, parseInt(txts[2]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })

            return result;
        }
        else{
            return '';
        }
    }

    handlePrintPreview(event,data,po_no,mom_no,html,url,product_type){
        this.props.startLoading()


        html = html.replace('style="padding-bottom: 140px;','style="padding-bottom: 0px;');
        const _vs = {...data,"headercomplete":"true",'no': `${po_no}/${mom_no}`};
        AdjustmentService.getDraftPDFFile({
            'id':0,
            'type':'',
            'filename':`ใบตรวจรับการจัดซื้อ-จัดจ้าง_${mom_no ?? ""}_${this.getDateNowText()}`,
            'template':'mom_receipt_draft',
            'body':html,
            'title':'',
            'values':_vs}).then(response=>{
                this.props.stopLoading()
            });

            if(url)
            {
                AdjustmentService.getPDFLink({url:url,filename:product_type === 'C'? `รายงานการประชุมการตรวจรับสินค้า_${mom_no ?? ""}_${this.getDateNowText()}.pdf`:`รายงานการประชุมการตรวจรับพัสดุ_${mom_no ?? ""}_${this.getDateNowText()}.pdf`}).then(response=>{
                this.setState({
                    openPrintFile: false
                })
                this.props.stopLoading();
            });
            }
            
    }

    getDateNowText()
    {
        const d = new Date();
        const y = d.getFullYear();
        const m = d.getMonth()+1;
        const day = d.getDay();

        return `${y}${m < 10 ? ('0'+m): m}${day < 10 ? ('0'+day): day}`;

    }
   
    handlePrint(event,data,po_no,mom_no,html){

        html = html.replace('style="padding-bottom: 140px;','style="padding-bottom: 0px;')
        const _vs = {...data,"headercomplete":true,'no': `${po_no}/${mom_no}`};
        this.setState({
            objPrint: {
                    'id':0,
                    'type':'',
                    'filename':`ใบตรวจรับการจัดซื้อ-จัดจ้าง_${mom_no ?? ""}_${this.getDateNowText()}`,
                    'template':'mom_receipt',
                    'body':html,
                    'title':'',
                    'values':_vs}
        })
      
        this.handleOnOpenPrintFile();
    }

    handleConfirmPrint(url, po_no,mom_no,product_type){
        this.props.startLoading()
        let _obj = {...this.state.objPrint,'template': this.state.hasPrintHeader ? "mom_receipt" : "mom_receipt_none_header"};

        AdjustmentService.getPDFFile({..._obj}).then(response=>{
                this.setState({
                    openPrintFile: false
                })
                this.props.stopLoading();
            });
            AdjustmentService.getPDFLink({url:url,filename: product_type === 'C'? `รายงานการประชุมการตรวจรับสินค้า_${mom_no ?? ""}_${this.getDateNowText()}.pdf`:`รายงานการประชุมการตรวจรับพัสดุ_${mom_no ?? ""}_${this.getDateNowText()}.pdf`}).then(response=>{
                this.setState({
                    openPrintFile: false
                })
                this.props.stopLoading();
            });
     


    }

    handleSetDrawHtml(){
        this.setState({draw_html:this.state.draw_html+1});
    }

    async handleChangeAuditCommitteeTimeToConsiderDate(date) {

        let {t_MR_DETAIL } = this.props
        if(t_MR_DETAIL.audit_committee_time_to_consider_flag === true)
        {
            
            AdjustmentService.getNextDayWithoutWeekEndAndHoliday(date, t_MR_DETAIL.audit_committee_time_to_consider).then(response=>{
                if(response.success === true)
                {
                    this.props.updateMR_Detail(response.data, "audit_committee_time_to_consider_date");
                   
                }
            })
        }
    }

    async handleShowCompleteDateAll(po_no){
        
        try{
            const response = await AdjustmentService.getMasterConfigs("CompletedDateAllDateByPoNoStart,CompletedDate_NotCheck_PoApproveDate");
            if(response)
            {
                if(response.length > 0)
                {
                    let completeDateByPos = [];
                    let completeDateNotCheckPoApproveDates = [];
                    const completedDateAllDateByPoNoStart = response.filter(p=>p.masterCode === 'CompletedDateAllDateByPoNoStart');
                    const completedDateNotCheckPoApproveDate = response.filter(p=>p.masterCode === 'CompletedDate_NotCheck_PoApproveDate');

                    if(completedDateAllDateByPoNoStart.length > 0)
                    {
                        completeDateByPos = (completedDateAllDateByPoNoStart[0].masterValue ?? "").split(',');
                        
                    }

                    if(completedDateNotCheckPoApproveDate.length > 0)
                    {
                        completeDateNotCheckPoApproveDates= (completedDateNotCheckPoApproveDate[0].masterValue ?? "").split(',');
                        
                    }

                    this.setState({
                        complete_date_by_po: completeDateByPos,
                        complete_date_notcheck_po_date: completeDateNotCheckPoApproveDates
                    })
                    
                }

                
            }
        }catch(error){
            console.log(error)
        }
    }

    handleCheckCompleteDateMode(po_no, product_type){
        let modeCompleteDate = '';
        const poStartsWiths = this.state.complete_date_by_po;
        const product_type_notcheck_po_dates = this.state.complete_date_notcheck_po_date;

        for(let i=0;i<poStartsWiths.length;i++)
        {
            if(po_no.startsWith(poStartsWiths[i]))
            {
                modeCompleteDate = 'all_ignore';
            }
        }

        for(let i=0;i<product_type_notcheck_po_dates.length;i++)
        {
            if(product_type_notcheck_po_dates[i] === product_type)
            {
                if(modeCompleteDate === '')
                {
                    modeCompleteDate = 'ignore_po_approve_date';
                }
            }
        }

        return modeCompleteDate;
    }

    handleCheckShowCompleteDateAll(po_no, product_type){
        let allDate = false;
        const poStartsWiths = this.state.complete_date_by_po;
        const product_type_notcheck_po_dates = this.state.complete_date_notcheck_po_date;

        for(let i=0;i<poStartsWiths.length;i++)
        {
            if(po_no.startsWith(poStartsWiths[i]))
            {
                allDate = true;
            }
        }

        for(let i=0;i<product_type_notcheck_po_dates.length;i++)
        {
            if(product_type_notcheck_po_dates[i] === product_type)
            {
                allDate = true;
            }
        }
        return allDate;
    }

    handleToCreateAuditCommitteeTime = async() => {
        let{t_PO_DETAIL}=this.props
        this.props.onClickToExtendConsiderationPeriodItem(`/ExtendConsiderationPeriodItem/0/${t_PO_DETAIL.po_contract_no}`);
    }

    

    render() {
        //console.log("PODetail.render()")
        let{
            t_PO_DETAIL,
            t_PO_COMMITTEE,
            t_MR_DETAIL,
            t_MR_ATTACHMENTS,
            t_HEADER,
            upload_files,
            transaction_no
        }=this.props
        const user = Storage.getUser()
        const role = Storage.getRole()
        const approver = t_PO_COMMITTEE.filter(committee => committee.code === user.userName  && committee.accept_status === null) 

        let {
            viewMode,
            appReadonly
        } = this.state
        let nexttab = null //this.props.docType === "BOT" ? "rrsTab3": null
        const url = t_MR_DETAIL.mom_url;

        let mom_html = null;
        let isEditHtml = true;

        let is_modify_fine = (t_HEADER.transaction_no===null) ||  (role == "R" && t_HEADER.createBy_role === "R" && (t_PO_DETAIL.status === "VERI" || t_PO_DETAIL.status === "DECL"  || t_PO_DETAIL.status === "WVER")) || ((role == "C" && t_HEADER.createBy_role === "C"))
           
        const contract_number_list_nsy = t_MR_DETAIL.contract_number_list_nsy ? t_MR_DETAIL.contract_number_list_nsy.split('||') : [];
       
        if(t_MR_DETAIL.transaction_no !== null && t_MR_DETAIL.mom_html !== '<div class="A4 water-mark water-mark-ie"></div>')
        {
            mom_html =  (t_MR_DETAIL.mom_html !==null && t_MR_DETAIL.mom_html !==undefined && t_MR_DETAIL.mom_html !=='' ?
            t_MR_DETAIL.mom_html:
            ParcelReceiptTemplate.replaceAll('{po_no}',t_PO_DETAIL.po_no_detail ? t_PO_DETAIL.po_no_detail : "").replaceAll('{po_header}', this.getDocNameForm(t_PO_DETAIL.document_name)).replaceAll('{po_commitee_type}', t_HEADER.product_type === "C"?"คณะกรรมการตรวจรับสินค้า": "คณะกรรมการตรวจรับพัสดุ"))

            if(mom_html === '<div class="A4 water-mark water-mark-ie"></div>')
            {
                console.log('case A')
                mom_html = ParcelReceiptTemplate.replaceAll('{po_no}',t_PO_DETAIL.po_no_detail ? t_PO_DETAIL.po_no_detail : "").replaceAll('{po_header}', this.getDocNameForm(t_PO_DETAIL.document_name)).replaceAll('{po_commitee_type}', t_HEADER.product_type === "C"?"คณะกรรมการตรวจรับสินค้า": "คณะกรรมการตรวจรับพัสดุ");
            }

            if(viewMode)
            {
                mom_html = mom_html.split('contenteditable="true"').join('contenteditable="false"')

                isEditHtml = false;
            }
    

            if((user.userName === t_HEADER.createBy || (role === 'R' &&(t_PO_DETAIL.status === "WVER" || t_PO_DETAIL.status === "VERI"))) === false)
            {
                console.log('case B')
                mom_html = mom_html.split('contenteditable="true"').join('contenteditable="false"')

                isEditHtml = false;
            }

            if(role === 'C')
            {
                if((t_PO_DETAIL.status === 'DRAF' || t_PO_DETAIL.status === 'REJT' || t_PO_DETAIL.status === 'DECL' || t_PO_DETAIL.status === 'VERI' || t_PO_DETAIL.status === 'WVER') === false)
                {
                //mom_html = mom_html.replaceAll('contenteditable="true"','contenteditable="false"')
                console.log('case C')
                mom_html = mom_html.split('contenteditable="true"').join('contenteditable="false"')
                isEditHtml = false;
                }
            }else if(role === 'R'){
                if((t_PO_DETAIL.status === 'DRAF' || t_PO_DETAIL.status === 'REJT' || t_PO_DETAIL.status === 'DECL' || t_PO_DETAIL.status === 'VERI' || t_PO_DETAIL.status === 'WVER') === false)
                {

                    console.log('case D')
                //mom_html = mom_html.replaceAll('contenteditable="true"','contenteditable="false"')
                mom_html = mom_html.split('contenteditable="true"').join('contenteditable="false"')
                isEditHtml = false;
                }
            }

            if (!(t_PO_DETAIL.status === 'DRAF' || t_PO_DETAIL.status === 'WVER' || t_PO_DETAIL.status === 'DECL' || t_PO_DETAIL.status === 'VERI' || t_PO_DETAIL.status === 'REJT' || t_PO_DETAIL.status === 'WACCEPT' ))
            {
                    mom_html = mom_html.replace("water-mark","").replace("water-mark-ie","")
            }
        }
       const data={
            "mom_date" : t_MR_DETAIL.mom_date ? this.toDateStringThai(t_MR_DETAIL.mom_date) : "",
            "po_no" : t_PO_DETAIL.po_no_detail ? t_PO_DETAIL.po_no_detail : "",
            "po_date" : t_PO_DETAIL.po_approve_date ? this.toDateStringThai(t_PO_DETAIL.po_approve_date) : "",
            "vendor_name" : t_PO_DETAIL.vendor_name? t_PO_DETAIL.vendor_name : "",
            "po_header" : this.getDocNameForm(t_PO_DETAIL.document_name),
            "period" : t_MR_DETAIL.installment_no_mr ? t_MR_DETAIL.installment_no_mr : "",
            "completed_date": t_MR_DETAIL.completed_date ? this.toDateStringThai(t_MR_DETAIL.completed_date) : "",
            "b_fine" : t_MR_DETAIL.penalty_result === "penalty" || (t_MR_DETAIL.penalty_result ==="no_penalty" && t_MR_DETAIL.delivery_exception_flag === "delay_time")? "true" :"false",
            "b_nofine" : t_MR_DETAIL.penalty_result !== "penalty" && !(t_MR_DETAIL.penalty_result ==="no_penalty" && t_MR_DETAIL.delivery_exception_flag === "delay_time")? "true" :"false",
            "b_completed" : "true",
            "b_notcompleted" : "false",

            "po_commitee_type": t_HEADER.product_type === "C"?"คณะกรรมการตรวจรับสินค้า": "คณะกรรมการตรวจรับพัสดุ"
        }

        const countNotApprove = t_PO_COMMITTEE.filter(w => w.approve_status === 'N') 
        let showApproveOrder = countNotApprove.length > 0
        
        //this.handleSetDrawHtml();
        //console.log("data on Momtetail ==> mom_html ==> " ,mom_html)
        return (
            // <div className="collapse show rrs-container-wrap" id="rrsTab1" aria-labelledby="rrsPoDetail" data-parent="#invoiceRecordingSystem">
             <div className="rrs-container-wrap collapse show" id="rrsTab2" aria-labelledby="rrsMOM" data-parent="#invoiceRecordingSystem">
               
                <div className="rrs-container">
                    {/* Start content tab 1 */}

                    <div className="rrs-detail2">


                        {t_PO_DETAIL.po_contract_no && (
                            <div className="rrs-result">
                                {/* Status */}
                                <div className="row rrs-status-wrap">
                                    <div className="col-3 rrs-panelstatus">
                                        <div className="sp-rrs-detail-label">Status : 
                                        {
                                             t_PO_DETAIL.status === 'DELE' ?
                                             <span className="text-danger ml-2" id="po-status">{this.getStatus(t_PO_DETAIL.status)}</span>
                                             :  <span className="sp-rrs-detail-data ml-2" id="po-status">{this.getStatus(t_PO_DETAIL.status)}</span>
                                        }

                                        </div>
                                        {/* <div className="sp-rrs-detail-data" id="po-status">{this.getStatus(t_PO_DETAIL.status)}</div> */}
                                    </div>
                                    <div className="col-5 rrs-panelstatus rrs-detail-item">
                                        { (t_PO_DETAIL.status === 'REJT' || t_PO_DETAIL.status === 'DECL')  && (
                                            <div className="sp-rrs-detail-label">สาเหตุส่งกลับแก้ไข : 
                                            <span className="sp-rrs-detail-data-reject ml-2" id="po-reject">{t_PO_DETAIL.reject_Option_Desc + ' ' + t_PO_DETAIL.reject_Result}</span></div>
                                        )}
                                        {
                                            t_PO_DETAIL.status === 'DELE' &&  <div className="sp-rrs-detail-label"> เหตุผล : 
                                            <span className="sp-rrs-detail-data-reject ml-2" id="po-reject">{t_PO_DETAIL.reason ?? ""} {t_PO_DETAIL.description ?? ""}</span></div>
                                        }
                                   </div>
                                    <div className="col-4 " style={{textAlign:'end'}}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            startIcon={<AccessTimeIcon />}
                                            onClick={()=>{this.handleOnOpenPOHistory()}}
                                        >
                                            History
                                        </Button>
                                    </div>
                                    {/* {((t_PO_DETAIL.status === 'REJT'|| t_PO_DETAIL.status === 'VERI') && t_PO_DETAIL.reject_Result ) ?
                                        <div className="col-9" style={{ paddingLeft: '58px' }}>
                                            <div className="sp-rrs-detail-label" style={{ fontSize: '1rem', fontWeight: 'bold' }} >สาเหตุส่งกลับแก้ไข</div>
                                            <div className="rrs-detail-data" id="rejectremark" style={{ marginTop: '10px', marginBottom: '20px' }}><span>*{t_PO_DETAIL.reject_Result}</span></div>
                                        </div> : null} */}
                                </div>
                                {/* PO No. box */}


                                <div className="row rrs-wrap">
                                    <div className="col-12 col-lg-3 rrs-panel">
                                        <div className="rrs-detail1">
                                            <div className="row rrs-detail-row">
                                                <div className="col-12 rrs-detail-item rrs-po-num">
                                                    <div className="rrs-detail-label rrs-detail-label-large">PO / Contract No.</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.po_contract_no}</div>
                                                </div>
                                                {/* <div className="col-12 rrs-detail-item rrs-mom">
                                                    <div className="rrs-detail-label rrs-detail-label-large">Ref. PO</div>
                                                    <div className="rrs-detail-data">{t_HEADER.ref_po}</div>
                                                </div>  */}
                                                <div className="col-12 rrs-detail-item rrs-mom">
                                                    <div className="rrs-detail-label rrs-detail-label-large">MOM Doc No.</div>
                                                    <div className="rrs-detail-data">{t_HEADER.mom_no}</div>
                                                </div>  
                                                { t_HEADER.doc_no && (     
                                                <div className="col-12 rrs-detail-item rrs-mom">
                                                    <div className="rrs-detail-label rrs-detail-label-large">RRS Doc No.</div>
                                                    <div className="rrs-detail-data">{t_HEADER.doc_no}</div>
                                                </div> 
                                                )}                                        
                                                <div className="col-12 rrs-detail-item rrs-vendor">
                                                    <div className="rrs-detail-label mr-1">Vendor Code</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.vendor_code}</div>
                                                </div>
                                                <div className="col-12 rrs-detail-item rrs-vendor">
                                                    <div className="rrs-detail-label mr-1">Vendor Name</div>
                                                    <div className="rrs-detail-data">{t_PO_DETAIL.vendor_name}</div>
                                                </div>
                                                <div className="col-12 rrs-detail-item rrs-createby pr-0">
                                                    <div className="rrs-detail-label">
                                                        <i className="icon icon-user" />พนักงานจัดหาผู้รับผิดชอบ PO/Contract</div>
                                                    <div className="rrs-detail-data">

                                                        <p className="rrs-detail-data-p">
                                                            {/* {t_PO_DETAIL.create_po_contract_emp_id + " " + t_PO_DETAIL.create_po_contract_emp_name} */}
                                                            {t_PO_DETAIL.create_po_contract_emp_name}
                                                        </p>
                                                        <p className="rrs-detail-data-p">{"หน่วยงาน : " + t_PO_DETAIL.create_po_contract_department_name}</p>
                                                    </div>
                                                </div>
                                                <div className="col-12 rrs-detail-item rrs-docdate">
                                                    <div className="row no-gutters">
                                                        <div className="rrs-detail-label"><i className="icon icon-time" />Document Date</div>
                                                        <div className="rrs-detail-data">
                                                            <span className="hilight">{t_PO_DETAIL.po_date ? moment(t_PO_DETAIL.po_date).format('DD/MM/YYYY') : ""}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-9 rrs-panel21">
                                        <div className="rrs-detail22">
                                            <div className="row rrs-detail-row">
                                                <div className="col-12 rrs-detail-item rrs-detail-item-docname">
                                                    <div className="rrs-detail-label">ชื่อเอกสาร</div>
                                                    <div className="rrs-detail-data">{this.getDocName(t_PO_DETAIL.document_name)}</div>
                                                </div>
                                            </div>
                                            <div className="row rrs-detail-row">

                <div className="col-12 col-lg-12 col-md-6 rrs-panel21"> 
                        <div className="row" style={{marginTop:10}}></div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="invoice_date_gr" id="lbl-gr_header_document_date" className="rrs-label mb-0"  style={{fontSize: '90%'}}><span className="required">*</span> วันที่ส่งมอบถูกต้องครบถ้วน</label>
                                    {/* <img className="icon-info2" 
                                        scr="..assets/images/icons/iconinfo.png"
                                    /> */}
                                    <Information>
                                    <p>- วันที่คู่สัญญามาส่งมอบแล้ว คณะกรรมการตรวจรับฯมีความเห็นว่า ที่ได้รับถูกต้องครบถ้วนตามเงื่อนไขข้อกำหนดสัญญา</p>
                                    <p>- กรณีไม่มีการจัดทำหนังสือสนอง: ลงวันที่ย้อนหลังไม่ได้</p>
                                    <p>- กรณีมีการจัดทำหนังสือสนอง: ลงวันที่ย้อนหลังได้ไม่เกินวันที่ลงนามในใบสั่ง/หนังสือสนอง</p>
                                    </Information>
                                    <div className="rrs-detail-data">
                                    <DatePicker
                                    name="completed_date"
                                    id="completed_date"
                                    placeholder="dd/mm/yyyy"
                                    data-date-format="dd/mm/yyyy"
                                    value={this.props.t_MR_DETAIL.completed_date
                                        ? moment(this.props.t_MR_DETAIL.completed_date).format('DD/MM/YYYY')
                                        : ""}
                                    onChange={this.handleChange}
                                    onBlur={this.handleChange}
                                    doctype="*"
                                    showsdayall={()=>(this.handleCheckShowCompleteDateAll(t_PO_DETAIL.po_contract_no, t_HEADER.product_type))}
                                    tagid="mr.completed_date"
                                    disabled={viewMode}
                                    viewMode={viewMode}
                                    readOnly={true}
                                // showsdayall={"All"}
                                />
                                    </div>
                                </div>
                            </div>
                            { t_MR_DETAIL.audit_committee_time_to_consider_flag === true &&
                                <>
                                    <div className="col-md-4">
                                        <div className="rrs-form">
                                            <label htmlFor="audit_committee_time_to_consider" id="lbl-gr_header_audit_committee_time_to_consider" className="rrs-label mb-0" style={{fontSize: '90%'}}>ระยะเวลาพิจารณาของ คกก.ตรวจรับพัสดุ</label>
                                            
                                            <Information>
                                            ในการตรวจรับงานแต่ละงวด คณะกรรมการตรวจรับพัสดุต้องดำเนินการให้แล้วเสร็จภายในกำหนดระยะเวลาในการพิจารณาของคณะกรรมการตรวจรับพัสดุ โดยเริ่มนับตั้งแต่วันที่ส่งมอบถูกต้องครบถ้วนจนถึงวันที่คณะกรรมการตรวจรับพัสดุทุกคนต้องดำเนินการตรวจรับและยืนยันข้อมูลบันทึกการตรวจรับ (MOM) ในระบบ RRS ให้แล้วเสร็จ ทั้งนี้ หากมีเหตุที่ทำให้การดำเนินงานล่าช้า จะต้องเสนอผู้มีอำนาจอนุมัติสั่งซื้อสั่งจ้างพัสดุพิจารณาขยายระยะเวลาให้ตามความจำเป็น
                                            </Information>
                                            <div className="rrs-detail-data">
                                                <input
                                                    key={`audit_committee_time_to_consider${t_MR_DETAIL.transaction_no}`}
                                                    type="text"
                                                    id="audit_committee_time_to_consider"
                                                    name="audit_committee_time_to_consider"
                                                    value={t_MR_DETAIL.audit_committee_time_to_consider + " วันทำการ"}
                                                    className="form-control"
                                                    doctype="*"
                                                    // tagid="mr.installment"
                                                    disabled="disabled"
                                                    maxlength="50"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="rrs-form">
                                            <label htmlFor="audit_committee_time_to_consider_date" id="lbl-gr_header_audit_committee_time_to_consider" className="rrs-label mb-0" style={{fontSize: '90%'}}>กำหนดวันที่ คกก.ตรวจรับพัสดุ ต้องพิจารณาแล้วเสร็จ</label>

                                            <div className="rrs-detail-data">
                                                <input
                                                    key={`audit_committee_time_to_consider_date${t_MR_DETAIL.transaction_no}`}
                                                    type="text"
                                                    id="audit_committee_time_to_consider_date"
                                                    name="audit_committee_time_to_consider_date"
                                                    value={t_MR_DETAIL.audit_committee_time_to_consider_date
                                                        ? moment(t_MR_DETAIL.audit_committee_time_to_consider_date).format('DD/MM/YYYY')
                                                        : ""}
                                                    className="form-control"
                                                    doctype="*"
                                                    // tagid="mr.installment"
                                                    disabled="disabled"
                                                    maxlength="50"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    { ((approver.length > 0 && t_PO_DETAIL.status==='WACCEPT' ) ||viewMode === false)  && ['WACCEPT','WVER', 'VERI' ,'DRAFT', 'DRAF'].includes(t_PO_DETAIL.status) && <div className="col-md-12" style={{paddingBottom: 8}}>
                                            <Typography variant="body2" style={{fontSize: '0.924rem'}}>กรณีเกินกำหนดระยะเวลาพิจารณาของคณะกรรมการตรวจรับ ให้เสนอผู้มีอำนาจอนุมัติสั่งซื้อสั่งจ้าง พิจารณาขยายให้ตามความจำเป็น <Button variant="contained" style={{marginLeft: 8, backgroundColor: '#0072bb', color: '#ffffff', padding: 8, borderRadius: 8, fontSize: '1rem'}} 
                                                    onClick={() => this.handleToCreateAuditCommitteeTime()}>&nbsp;ขยายระยะเวลาพิจารณา&nbsp;</Button></Typography>
                                    </div>}
                                </>
                            }
                            
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="mom_committee_date" id="lbl-gr_header_committee_date" className="rrs-label mb-0" style={{fontSize: '90%'}}><span className="required">*</span> ที่ประชุมมีมติวันที่</label>

                                    <div className="rrs-detail-data">
                                    <DatePicker
                                    name="mom_date"
                                    id="mom_date"
                                    placeholder="dd/mm/yyyy"
                                    data-date-format="dd/mm/yyyy"
                                    value={this.props.t_MR_DETAIL.mom_date
                                        ? moment(this.props.t_MR_DETAIL.mom_date).format('DD/MM/YYYY')
                                        : ""}
                                    onChange={this.handleChange}
                                    onBlur={this.handleChange}
                                    doctype="*"
                                    tagid="mr.mom_date"
                                    disabled={viewMode}
                                    viewMode={viewMode}
                                    readOnly={true}
                                // showsdayall={"All"}
                                />
                                    </div>
                                </div>
                            </div>
                        
                         
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="mom_committee_date" id="lbl-gr_header_po_approve_date" className="rrs-label mb-0" style={{fontSize: '90%'}}><span className="required">*</span>วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา
                                    <Information left={-570} bottom ={-97} width={570}>
                                    <p style={{marginBottom:0}}><span style={{"text-decoration":"underline"}}>ข้อสังเกตุ</span></p>
                                    <p style={{marginBottom:0}}>1. สำหรับงานจัดหาเชิงพาณิชย์ ให้ระบุดังนี้</p>
                                    <p style={{marginBottom:0, paddingLeft: 16}}>1.1 กรณีเป็นใบสั่ง ให้ระบุวันที่ลงนามใบสั่ง</p>
                                    <p style={{marginBottom:0, paddingLeft: 16}}>1.2 กรณีเป็นสัญญาที่มีการทำหนังสือสนองด้วย ให้ระบุวันที่ลงนามหนังสือสนอง</p>
                                    <p style={{marginBottom:0, paddingLeft: 16}}>1.3 กรณีเป็นสัญญาที่ไม่มีการทำหนังสือสนอง ให้ระบุวันที่ลงนามสัญญา</p>
                                    <p style={{marginBottom:0}}>&nbsp;</p>
                                    <p style={{marginBottom:0}}>2. สำหรับงานจัดซื้อจัดจ้างพัสดุ ให้ระบุวันที่ลงนามใบสั่งหรือวันที่ลงนามสัญญา</p></Information>
                                    </label>

                                    <div className="rrs-detail-data">
                                    <DatePicker 
                                    name="po_approve_date"
                                    id="po_approve_date"
                                    placeholder="dd/mm/yyyy"
                                    data-date-format="dd/mm/yyyy"
                                    value={this.props.t_PO_DETAIL.po_approve_date
                                        ? moment(this.props.t_PO_DETAIL.po_approve_date).format('DD/MM/YYYY')
                                        : ""}
                                    onChange={this.handleChange}
                                    onBlur={this.handleChange}
                                    doctype="*"
                                    tagid="mr.po_approve_date"
                                    disabled={viewMode }// || this.props.t_PO_DETAIL.po_approve_date_flag}
                                    viewMode={viewMode }//|| this.props.t_PO_DETAIL.po_approve_date_flag}
                                    readOnly={true}
                                    showsdayall={()=>(this.handleCheckShowCompleteDateAll(t_PO_DETAIL.po_contract_no, t_HEADER.product_type))}
                                />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="approver_name" id="#lbl-mr.approver" className="rrs-label"  style={{fontSize: '90%'}}>
                                        <span className="required">*</span> ผู้อนุมัติ  
                                            </label>
                                    <div className="rrs-detail-data">
                                        <Input
                                            key={`approver_name${t_MR_DETAIL.transaction_no}`}
                                            value={this.formatDisplayEmployeeApprover(t_MR_DETAIL.approver_code, t_MR_DETAIL.approver_name)}
                                            className="form-control form-control-search-2"
                                            id="approver_name"
                                            name="approver_name"
                                            onClick={() => this.searchEmployeeModal("approver_code", "approver_name")}
                                            readOnly={true && !viewMode}
                                            doctype="*"
                                            tagid="mr.approver"
                                            viewMode={viewMode}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="receiver_name" id="#lbl-mr.receiver" className="rrs-label" style={{fontSize: '90%'}}>
                                        <span className="required">*</span> ชื่อผู้รับงาน
                                            </label>
                                    <div className="rrs-detail-data">
                                        <Input
                                            key={`approver_name${t_MR_DETAIL.transaction_no}`}
                                            value={this.formatDisplayEmployee(t_MR_DETAIL.receiver_code, t_MR_DETAIL.receiver_name)}
                                            className="form-control form-control-search-2"
                                            id="receiver_name"
                                            name="receiver_name"
                                            onClick={() => this.searchEmployeeModal("receiver_code", "receiver_name")}
                                            readOnly={true && !viewMode}
                                            doctype="*"
                                            tagid="mr.receiver"
                                            disabled={viewMode}
                                            viewMode={viewMode}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4" disable={viewMode ? "disabled" : null} >
                                <div className="rrs-form">
                                    <label htmlFor="installment_no_mr" id="#lbl-mr.installment" className="rrs-label">
                                    <span className="required">*</span>งวดที่
                                            </label>
                                    <div className="d-md-flex align-items-center">
                                        <div className="col-8 rrs-detail-data pl-0">
                                            <input
                                                key={`installment_no_mr${t_MR_DETAIL.transaction_no}`}
                                                type="text"
                                                id="installment_no_mr"
                                                name="installment_no_mr"
                                                value={t_MR_DETAIL.installment_no_mr}
                                                className="form-control"
                                                onChange={this.handleChange}
                                                onBlur={this.handleChange}
                                                doctype="*"
                                                // tagid="mr.installment"
                                                disabled={viewMode ? "disabled" : null} //{viewMode}
                                                maxlength="50"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                        <div className="col-auto px-0">
                                            <label className={`checkboxcontainer rrs-fine-label mb-0 ${viewMode ? '' : 'clickable'}`}> งวดสุดท้าย
                                                        <input
                                                    className={viewMode ? "form-control.form-control-gray1" : ""}
                                                    type="checkbox"
                                                    key={`final_installment_flag${t_MR_DETAIL.transaction_no}`}
                                                    name="final_installment_flag"
                                                    onChange={this.handleChange}
                                                    id="final_installment_flag"
                                                    checked={this.toBoolean(t_MR_DETAIL.final_installment_flag)}
                                                    disabled={viewMode}
                                                    viewMode={viewMode}
                                                />
                                                <span className="checkboxmark" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="date_of_signing_the_contract_nsy" id="#lbl_date_of_signing_the_contract_nsy" className="rrs-label"  style={{fontSize: '90%'}}>วันที่ลงนามหนังสือสัญญา นสญ.</label>
                                   
                                    <div className="rrs-detail-data">
                                    <DatePicker
                                        name="date_of_signing_the_contract_nsy"
                                        id="date_of_signing_the_contract_nsy"
                                        placeholder="dd/mm/yyyy"
                                        data-date-format="dd/mm/yyyy"
                                        value={this.props.t_MR_DETAIL.date_of_signing_the_contract_nsy ? moment(this.props.t_MR_DETAIL.date_of_signing_the_contract_nsy).format('DD/MM/YYYY') : ""}
                                        onChange={this.handleChange}
                                        onBlur={this.handleChange}
                                        doctype="*"
                                        tagid="mr.date_of_signing_the_contract_nsy"
                                        disabled={viewMode}
                                        viewMode={viewMode}
                                        readOnly={true}
                                    // showsdayall={"All"}
                                    />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="contract_number_nsy" id="#lbl-mr.contract_number_nsy" className="rrs-label" style={{fontSize: '90%'}}>เลขที่หนังสือสัญญา นสญ.</label>
                                    <Information wisth={670}>
                                        <p>ประวัติการเปลี่ยนแปลง</p>
                                        {
                                            contract_number_list_nsy.map((p)=> <p>{p}</p>)
                                        }
                                    </Information>
                                    <div className="rrs-detail-data">
                                        <input
                                                key={`contract_number_nsy${t_MR_DETAIL.transaction_no}`}
                                                type="text"
                                                id="contract_number_nsy"
                                                name="contract_number_nsy"
                                                value={t_MR_DETAIL.contract_number_nsy}
                                                className="form-control"
                                                onChange={this.handleChange}
                                                onBlur={this.handleChange}
                                                doctype="*"
                                                // tagid="mr.installment"
                                                disabled={viewMode ? "disabled" : null} //{viewMode}
                                                maxlength="50"
                                                viewMode={viewMode}
                                                autoComplete="off"
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 pr-md-12">
                            <div className="rrs-form">
                                <label htmlFor="cc" className="rrs-label" style={{fontSize: '90%'}}>รายละเอียดพัสดุ/สินค้าที่ตรวจรับ และรายละเอียดอื่นๆ (ถ้ามี) </label>
                                <div className="rrs-detail-data">
                                    <textarea
                                        cols={30}
                                        rows={50}
                                        key={`mom_comment${t_MR_DETAIL.transaction_no}`}
                                        name="mom_comment"
                                        onChange={this.handleChange}
                                        id="mom_comment"
                                        value={t_MR_DETAIL.mom_comment != null ? t_MR_DETAIL.mom_comment : ''}
                                        className="form-control rrs-textarea"
                                        disabled={viewMode}
                                        maxlength="400"
                                        //placeholder = "Workaround ให้ระบุ PO Item ที่จะรับ และ ระบุ Exchange Rate ในช่องนี้ ก็จะแสดงในรายงาน MOM"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                                           
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                            <HeaderTable tableName="ผลบันทึกการตรวจรับ" id="htResult">

                                        <div className="sp-page-wrapper">
                        <div className="sp-table-container">
                            <div className="row no-gutters">
                                            <table className="sp-table table rrs-table rrs-table-purple">
                                                <thead>
                                                    <tr className="sp-table-header">
                                                        {/* <th className="th-no"><div className="th-text">ลำดับ</div></th> */}
                                                        <th className="th-docnum"><div className="th-text">ชื่อ - นามสกุล</div></th>
                                                        <th className="th-projectname"><div className="th-text">หน่วยงาน</div></th>
                                                        <th className="th-budget"><div className="th-text">โทรศัพท์</div></th>
                                                        <th className="th-method"><div className="th-text">Email</div></th>
                                                        <th className="centerdata th-method"><div className="th-text">ผลการตรวจรับ</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {t_PO_COMMITTEE && (t_PO_COMMITTEE).map((item, index) => (
                                                        <>
                                                        <tr key={index + 1}>
                                                            {/* <td className="td-num">{item.sequence}</td> */}
                                                            <td className="nowrap-whitespace">{item.fullname}</td>
                                                            <td className="nowrap-whitespace">{item.department}</td>
                                                            <td className="nowrap-whitespace">{item.telephone}</td>
                                                            <td><a href={"mailto:" + item.email + ";"}>{item.email}</a></td>
                                                            <td>
                                                                <div className="rrs-detail-data">
                                                                    <div className="row">
                                                                    <div className="col-auto">
                                                                        <label className={`radiocontainer ${viewMode?'':'clickable'}`}>อนุมัติตรวจรับ
                                                                            <input
                                                                                type="radio"
                                                                                name={"approve_status" + index}
                                                                                defaultValue="Y"
                                                                                checked={(t_PO_COMMITTEE[index].approve_status === "Y")}
                                                                                
                                                                                onChange= {(event) => { this.handleCangeApprove(event, index) }}
                                                                                ref={this.no_evaluation_ref}
                                                                                disabled={viewMode || !is_modify_fine}
                                                                            />
                                                                            <span className="checkmark" />
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        {/* <label className={`radiocontainer ${viewMode?'':'clickable'}`}>ไม่อนุมัติตรวจรับ
                                                                            <input
                                                                                type="radio"
                                                                                name={"approve_status"+ index}
                                                                                defaultValue="N"
                                                                                checked={(t_PO_COMMITTEE[index].approve_status === "N" || t_MR_ATTACHMENTS.filter(w => w.file_category === 'A' +(index+1) ).length > 0)}
                                                                                onChange={(event) => { this.handleCangeApprove(event, index) }}
                                                                                ref={this.genaral_evaluation_ref}
                                                                                disabled={viewMode}
                                                                            />
                                                                            <span className="checkmark" />
                                                                        </label> */}
                                                                        <UploadRadio
                                                                                lableName = {"ไม่อนุมัติตรวจรับ"}
                                                                                type="radio"
                                                                                name={"approve_status"+ index}
                                                                                defaultValue="N"
                                                                                value={t_PO_COMMITTEE[index].approve_status}
                                                                                checked={(t_PO_COMMITTEE[index].approve_status === "N")}
                                                                                onChange={(event) => { this.handleCangeApprove(event, index) }}
                                                                                ref={this.genaral_evaluation_ref}
                                                                                disabled={viewMode || !is_modify_fine} //(t_HEADER.createBy !== user.userName && t_HEADER.running != null)
                                                                                transaction_no={this.getTransNo()}
                                                                                modalId={'attachedDocumentNotAppModal' + (index+1)}
                                                                                viewMode={viewMode || !is_modify_fine } //(t_HEADER.createBy !== user.userName && t_HEADER.running != null)
                                                                                defaultFileName={'รายงานความเห็นแย้ง'}
                                                                                approver_id = {this.formatDisplayEmployeeApprover(t_MR_DETAIL.approver_code, t_MR_DETAIL.approver_name)}
                                                                                file_category={"A" + (index+1)}
                                                                                onUploadComplete = {(event)=>this.onUploadFileComplete(event, index)}
                                                                                onUploadCancel = {(event)=>this.onUploadFileComplete(event, index)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-auto">
                                                                       {/* <a> <label >ความคิดเห็นเพิ่มเติม
                                                                        </label></a> */}
                                                                    
                                                                        <ACollapse  id={"comment_"+index} tableName ='ความคิดเห็นเพิ่มเติม' ShowButton='N' >

                                                                        </ACollapse>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr></tr>
                                                        <tr>
                                                            <td colSpan="1"></td>
                                                            <td colSpan="5">
                                                            <CollapseDetail id={"comment_"+ index} isExpand= {upload_files?((upload_files.filter(w => w.file_category === ('A' +(index+1))).length > 0) ? 'N': 'Y'):'N'}>
                                                            {/* <div className="sp-page-wrapper">
                                                                <div className="sp-table-container">
                                                                    <div className="showhide-detail-button"> */}
                                                                    <div className="btn-showhide-detail3">
                                                                        <div className="row sp-table-content">
                                                                            <div className="col-12 rrs-detail-data d-flex ">
                                                                                    <label htmlFor="cc" className="rrs-label rrs-label-95">
                                                                                    {
                                                                                        //t_MR_DETAIL.delivery_exception_flag == "delay_time" 
                                                                                        (t_PO_COMMITTEE[index].approve_status === "N") && (<span className="required">*</span>)
                                                                                    }ความเห็นเพิ่มเติม : </label>
                                                                                    <div className="col-xl-10 rrs-detail-data">
                                                                                        <textarea
                                                                                            cols={80}
                                                                                            key={`comment+${ index + "_" + t_MR_DETAIL.transaction_no}`}
                                                                                            name={"comment_" + index}
                                                                                            id={"comment_" + index}
                                                                                            className="form-control"
                                                                                            value={item.comment != null ? item.comment:''}
                                                                                            onChange={(event) => { this.handleCangeComment(event, index) }}
                                                                                            disabled={viewMode || !is_modify_fine } //(t_HEADER.createBy !== user.userName && t_HEADER.running != null)
                                                                                            maxLength="3000"
                                                                                            />
                                                                                    </div>
                                                                                    {/* <UploadButton
                                                                                        transaction_no={transaction_no}
                                                                                        modalId={'attachedDocumentNotAppModal'}
                                                                                        viewMode={viewMode}
                                                                                        defaultFileName={'รายงานความเห็นแย้ง'}
                                                                                        file_category={'A'+index}
                                                                                        closeModel= {this.closeModel()}
                                                                                    /> */}
                                                                                    </div>
                                                                                </div>
                                                                       {/* {true===true && ( */}
                                                                        <div className="row sp-table-content">
                                                                        <div className="col-12  rrs-detail-data d-flex">        
                                                                              {/* <div col-2>  <label htmlFor="cc" className="rrs-label rrs-label-95">
                                                                                    แนบรายงานความเห็นแย้ง : </label></div> */}
                                                                                    <div className="col-10">
                                                                                    {/* <div className="rrs-detail-data"> */}
                                                                                        <UploadLisNoHead 
                                                                                        key={"uploadlist-mr-" + utilityHelper.genDateKey()}
                                                                                        transaction_no={this.getTransNo()}
                                                                                        file_category={'A'+(index+1)}
                                                                                        viewMode={viewMode || !is_modify_fine} // (t_HEADER.createBy !== user.userName && t_HEADER.running != null)
                                                                                        onDeleteComplete = {(event,iindex) => { this.onDeleteComplete(event, index) }}
                                                                                        isShow={t_PO_COMMITTEE[index].approve_status === "N"?"Y":null}
                                                                                        modalId={'attachedDocumentNotAppModal' + (index+1)}
                                                                                        />
                                                                                        {/* <UploadList
                                                                                        key={"uploadlist-mr-" + utilityHelper.genDateKey()}
                                                                                        transaction_no={transaction_no}
                                                                                        file_category={'A'+(index+1)}
                                                                                        viewMode={viewMode}
                                                                                        /> */}
                                                                                        {/* </div> */}
                                                                                        </div>
                                                                        </div>                                                                            
                                                                        </div>
                                                                         {/* )} */}


                                                                    </div>    
                
                                                                    {/* </div>
                                                                </div>
                                                            </div> */}
                                                            </CollapseDetail>
                                                            </td>
                                                        </tr>
                                                        </>
                                                    ))}
                                                </tbody>
                                            </table>
                                    

                                    </div>
                                </div>
                            </div> 
                            { (showApproveOrder) && (
                           <PanelNotApprove 
                           tableName="ข้อมูลอนุมัติสั่งการรับหรือไม่รับ"
                           //t_MR_DETAIL = {t_MR_DETAIL}
                           //visibled = {showApproveOrder}
                           viewMode={viewMode || !is_modify_fine}
                           >
                          
                           </PanelNotApprove> 
                             )}
                           </HeaderTable>
                            <HeaderTable tableName="แนบเอกสารประกอบการตรวจรับ และเอกสารที่เกี่ยวข้อง (ถ้ามี) เช่น หลักฐานแสดงพัสดุ/สินค้า/งาน ที่ส่งมอบ หลักฐานประกอบการตรวจรับงาน หลักฐานเกี่ยวกับการชำระเงิน/ภาษี เป็นต้น" id="htAttach">
                    <div className="sp-page-wrapper">
                        <div className="sp-table-container">
                            <div className="row no-gutters sp-table-content row mt-0 mb-2 pt-3">
                            <div className="col-lg-12">
                                <div className="sp-header-button-panel2 justify-content-end">
                                    <UploadButton
                                        transaction_no={this.getTransNo()}
                                        modalId={'attachedDocumentNormalModal'}
                                        viewMode={viewMode}
                                        defaultFileName={'เอกสารแนบ'}
                                        file_category={'N'}
                                    />
                                </div>
                            </div>

                        <div className="col-lg-12">
                            <div className="row no-gutters sp-table-content">

                                <UploadList
                                    key={"uploadlist-mr-" + utilityHelper.genDateKey()}
                                    transaction_no={transaction_no}
                                    file_category={'N'}
                                    viewMode={viewMode}
                                />
                            </div>
                        </div>
                            </div>
                                </div>
                            </div>                            
                          
                          
                            </HeaderTable>
                            <HeaderTable tableName="รายละเอียดค่าปรับ (ถ้ามี)" id ="htpatian">
                    {/*Section4->รายละเอียดค่าปรับ*/}
  
                        {/* collapse button 1 */}


                            <PanelFineMom
                                handleChange={this.handleChange}
                                handleChangeByName={this.handleChangeByName}
                                upload_files={this.props.upload_files}
                                t_MR_DETAIL={this.props.t_MR_DETAIL}
                                t_HEADER={this.props.t_HEADER}
                                currency={this.props.t_PO_DETAIL.currency}
                                viewMode={viewMode || !is_modify_fine }
                                po_contract_no={this.props.t_PO_DETAIL.po_contract_no}
                                id ={"1"}
                            />               

                    {/* End content tab 4 */}
                            </HeaderTable>
                            <HeaderTable tableName="แบบฟอร์มบันทึกการตรวจรับ" id ="htFromMR" isExpand='Y'
                            element={<span style={{float:'right',color:'#dc3545'}}>กรุณากด "บันทึก" ทุกครั้งเมื่อมีการเปลี่ยนแปลงผลการตรวจ</span>}
                            >
                            <div className="sp-page-wrapper">
                                <div className="sp-table-container">
                                    {/* <div className="row no-gutters sp-table-content row mt-0 mb-2 pt-3"> */}
                                    {/* <ReactQuill theme="snow"
                                        modules={modules}
                                        formats={formats} value={this.state.text} style={{width:"100%",height:"400px"}}
                                        onChange={this.handleChangeQuill} /> */}
                                        {/* <Document
                                            file={url}
                                            //onLoadSuccess={onDocumentLoadSuccess}
                                            >
                                            <Page pageNumber={pageNumber} />
                                        </Document> */}
                                         
                                        { t_MR_DETAIL.receipt_url ? (<div className="all-page-container" style={{height: 1800, maxHeight: 1800, backgroundColor: '#cccccc'}}><AllPagesPDFViewer errorMessage={<span style={{color:'#eb5a46'}}>กรุณาระบุข้อมูลผลการตรวจรับให้ครบถ้วน</span>} pdf={t_MR_DETAIL.receipt_url ? t_MR_DETAIL.receipt_url.replace("http://","https://" ) + (`&draw=${this.state.draw}`)+`&dnow=${Date.now()}` : ""}  /></div>)
                                        : (<div className="all-page-container"><span>กรุณาบันทึกรายการก่อน เรียกดูแบบฟอร์ม</span></div>)}
                                        
                                    {/* </div> */}
                                </div>
                            </div>

                            </HeaderTable>
                            <HeaderTable tableName="ใบตรวจรับการจัดซื้อ/จัดจ้าง" id ="htpFormCustomer" isExpand='Y' >
                            <div className="sp-table-container">
                                <div className="sp-page-wrapper">
                                    <div className="sp-table-container">
                                        <div className="row no-gutters sp-table-content row mt-0 mb-2 pt-3">
                                            <PanelProductEdit 
                                            key={'PanelProductEdit-v0'}
                                            id={'PanelProductEdit-v0'}
                                            name={'PanelProductEdit-v0'}
                                            editChange={(_html)=>this.editChange(_html, isEditHtml)} 
                                            template={mom_html} 
                                            data={data}
                                             viewMode={role === 'C' ? (t_PO_DETAIL.status === 'DRAF' || t_PO_DETAIL.status === 'REJT' || t_PO_DETAIL.status === 'DECL' || t_PO_DETAIL.status === 'VERI' || t_PO_DETAIL.status === 'WVER') : 
                                             role === 'R' ? (t_PO_DETAIL.status === 'DRAF' || t_PO_DETAIL.status === 'REJT' || t_PO_DETAIL.status === 'DECL' || t_PO_DETAIL.status === 'VERI' || t_PO_DETAIL.status === 'WVER') : true}
                                            //disabled={viewMode}
                                            height={1320}
                                            ></PanelProductEdit>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </HeaderTable>
                            <div className="sp-page-wrapper">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content row mt-0 mb-2 pt-3">
                                    {/* <ReactQuill theme="snow"
                                        modules={modules}
                                        formats={formats} 
                                        value={this.state.text} style={{width:"100%",height:"400px"}}
                                        onChange={this.handleChangeQuill} >
                                    </ReactQuill> */}
                                    </div>
                                </div>
                            </div>    
                            <div className="sp-page-wrapper">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content row mt-0 mb-2 pt-3">
                                        <img 
                                           className="image-52"
                                           source="../images/image-52.png"></img>
                                    </div>
                                </div>
                            </div>
                            <div className="sp-page-wrapper">
                        <div className="sp-table-container">
                            <div className="row no-gutters">
                                            <table className="sp-table table rrs-table rrs-table-purple">
                                                <thead>
                                                    <tr className="sp-table-header">
                                                        {/* <th className="th-no"><div className="th-text">ลำดับ</div></th> */}
                                                        <th className="th-docnum"><div className="th-text">ชื่อ - นามสกุล</div></th>
                                                        <th className="th-projectname"><div className="th-text">หน่วยงาน</div></th>
                                                        <th className="th-budget"><div className="th-text">โทรศัพท์</div></th>
                                                        <th className="th-method"><div className="th-text">Email</div></th>
                                                        <th className="centerdata th-method"><div className="th-text">ผลการตรวจรับ</div></th>
                                                        <th className="centerdata th-method"><div className="th-text">วันที่ตรวจรับ</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {t_PO_COMMITTEE && (t_PO_COMMITTEE).map((item, index) => (
                                                        <tr key={index + 1}>
                                                            {/* <td className="td-num">{item.sequence}</td> */}
                                                            <td className="nowrap-whitespace">{item.fullname + " (" +item.code +")"}</td>
                                                            <td className="nowrap-whitespace">{item.department}</td>
                                                            <td className="nowrap-whitespace">{item.telephone}</td>
                                                            <td><a href={"mailto:" + item.email + ";"}>{item.email}</a></td>
                                                            <td className="nowrap-whitespace">{item.accept_status===null?'':item.accept_status ==='A'?'อนุมัติตรวจรับงาน': 'ไม่อนุมัติตรวจรับงาน'}</td>
                                                            <td className="nowrap-whitespace">{item.accept_date? moment(item.accept_date).format('DD/MM/YYYY'): ""}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                    

                                    </div>
                                </div>
                            </div> 

                            { t_PO_DETAIL.status ==='DELE' &&  <HeaderTable tableName="เอกสารประกอบการลบ MOM" id ="htpatian"><div className="sp-page-wrapper">
                                <div className="sp-table-container">
                                    <div className="row no-gutters">
                                           <MomDetailDeleteMOMView transaction_no={t_PO_DETAIL.transaction_no}></MomDetailDeleteMOMView>
                                    </div>
                                </div>
                            </div></HeaderTable> }
                                                          
                            
                    {(t_PO_DETAIL.po_contract_no != null) && (    
                        <div className="rrs-detail py-1">
                            <div className="row sp-table-content-footer">
                               

                            {
                                 this.props.viewMode===false &&  t_PO_DETAIL.status !=='WACCEPT' && (
                                    <div className="col-12 sp-header-button-panel2 justify-content-center" style={{ visibility: this.props.viewMode ? "hidden" : "visible",height:this.props.viewMode ? "0px" : "auto" }} >
                                    
                                    { (t_PO_DETAIL.status === 'BCFM'
                                    || t_PO_DETAIL.status === 'MCFM'
                                    || t_PO_DETAIL.status === 'MCOM'
                                    || t_PO_DETAIL.status === 'BPRO'
                                    || t_PO_DETAIL.status === 'BCOM'
                                    || t_PO_DETAIL.status === 'BPCO'
                                    || t_PO_DETAIL.status === 'BINC'
                                    || t_PO_DETAIL.status === 'DELE'
                                    || t_PO_DETAIL.status === 'WACCEPT'
                                    || t_PO_DETAIL.status === 'ACCEPT'
                                    || t_PO_DETAIL.status === 'PCOM') === false 
                                    && t_HEADER.transaction_no !== null
                                    &&
                                    <a className="sp-btn-icon" 
                                        onClick={(event) => { this.handlePrintPreview(event, data,t_PO_DETAIL.po_contract_no,t_HEADER.mom_no,mom_html,t_MR_DETAIL.receipt_url ? t_MR_DETAIL.receipt_url.replace("http://","https://" ): "",t_HEADER.product_type) }} >
                                        <i className="icon btn-print-orange" />
                                        <span className="sp-btn-icon-label4">Print Preview</span>
                                    </a> }
                                    {t_MR_DETAIL.transaction_no !== "" && this.props.docType === "NOTBOT"  && (t_HEADER.createBy === user.userName || t_HEADER.reviewer_code === user.userName) && (
                                            <a className="sp-btn-icon" onClick={() => { this.props.onHandleDelete("Transaction") }}>
                                                <i className="icon btn-order-delete" />
                                                <span className="sp-btn-icon-label2">Delete</span>
                                            </a>
                                        )}
                                    <a className="sp-btn-icon" onClick={(event) => { this.handleSubmit(event, this,null,null,nexttab) }} >
                                        <i className="icon btn-order-savedraft" />
                                        <span className="sp-btn-icon-label">Save</span>
                                    </a>

                                    {
                                     this.props.t_MR_DETAIL.transaction_no &&  this.props.docType && this.props.docType === "NOTBOT" && (

                                            <a className="sp-btn-icon" onClick={(event) => {this.openConfirmModal(event)}}>
                                                <i className={role==="C"?"icon btn-order-publish":"icon btn-approval-green"} />
                                                <span className="sp-btn-icon-label3">{role == "C"?"Submit":"Verify"}</span>
                                            </a>
                                      )
                                    }

                                    {role == "R" && this.props.docType && this.props.docType === "NOTBOT" && this.props.t_MR_DETAIL.transaction_no && t_HEADER.createBy !== user.userName && (t_PO_DETAIL.status === "WVER" || t_PO_DETAIL.stauts === "VERI") && (
                                        <a className="sp-btn-icon" onClick={() => this.openRejectModal()}>
                                            <i className="icon btn-reject-red" />
                                            <span className="sp-btn-icon-label2"  >Not Verify</span>
                                        </a>
                                    )}
                                </div>
                                 )
                                }

                                 { !appReadonly && <div className="col-12 sp-header-button-panel2 justify-content-center" style={{ visibility: (approver.length > 0 && t_PO_DETAIL.status=='WACCEPT'? "visible" :"hidden"  ),height:(approver.length > 0 && t_PO_DETAIL.status=='WACCEPT'? "auto" :"0px"  )}}>  {/*this.props.viewMode ?  (approver.length <= 0 || t_PO_DETAIL.status!='WACCEPT'? "hidden" : "visible" ) : (approver.length <= 0 || t_PO_DETAIL.status!='WACCEPT'? "hidden" : "visible" ) }}> */}
                                 { (t_PO_DETAIL.status === 'BCFM'
                                    || t_PO_DETAIL.status === 'MCFM'
                                    || t_PO_DETAIL.status === 'MCOM'
                                    || t_PO_DETAIL.status === 'BPRO'
                                    || t_PO_DETAIL.status === 'BCOM'
                                    || t_PO_DETAIL.status === 'BPCO'
                                    || t_PO_DETAIL.status === 'BINC'
                                    || t_PO_DETAIL.status === 'DELE'
                                    || t_PO_DETAIL.status === 'WACCEPT'
                                    || t_PO_DETAIL.status === 'ACCEPT'
                                    || t_PO_DETAIL.status === 'PCOM') === false 
                                    && t_HEADER.transaction_no !== null
                                    && <a className="sp-btn-icon" 
                                        onClick={(event) => { this.handlePrintPreview(event, data,t_PO_DETAIL.po_contract_no,t_HEADER.mom_no,mom_html,t_MR_DETAIL.receipt_url ? t_MR_DETAIL.receipt_url.replace("http://","https://" ): "",t_HEADER.product_type) }} >
                                        <i className="icon btn-print-orange" />
                                        <span className="sp-btn-icon-label4">Print Preview</span>
                                    </a>}
                                     
                                     {
                                        t_MR_DETAIL.audit_committee_time_to_consider_flag === true &&
                                        t_MR_DETAIL.audit_committee_time_to_consider_date && this.handleDateDiffNow(t_MR_DETAIL.audit_committee_time_to_consider_date) > 0
                                        ? <span style={{filter: 'grayscale(90%)'}}>
                                            <a className="sp-btn-icon" onClick={(event) => {}}> {/**/}
                                            <i className="icon btn-approval-green" />
                                            <span className="sp-btn-icon-label3">Accept</span>
                                        </a>
                                        </span> :
                                        <a className="sp-btn-icon" onClick={(event) => {this.handleSubmit(event, this, true,'ACCEPT') }}> {/**/}
                                            <i className="icon btn-approval-green" />
                                            <span className="sp-btn-icon-label3">Accept</span>
                                        </a>
                                     }
                                     
                                     {
                                        t_MR_DETAIL.audit_committee_time_to_consider_flag === true &&
                                        t_MR_DETAIL.audit_committee_time_to_consider_date && this.handleDateDiffNow(t_MR_DETAIL.audit_committee_time_to_consider_date) > 0
                                        ? <span style={{filter: 'grayscale(90%)'}}>
                                            <a className="sp-btn-icon" onClick={() => {}}> 
                                                <i className="icon btn-order-reject" />
                                                <span className="sp-btn-icon-label2">Decline</span>
                                            </a>
                                        </span> :
                                            <a className="sp-btn-icon" onClick={() => this.openRejectModal()}> 
                                                <i className="icon btn-order-reject" />
                                                <span className="sp-btn-icon-label2">Decline</span>
                                            </a>
                                    }
  
                                </div>}

                                { appReadonly 
                                && (approver.length > 0 || t_HEADER.createBy === user.userName || t_HEADER.reviewer_code === user.userName)
                                && (t_PO_DETAIL.status === 'BCFM'
                                    || t_PO_DETAIL.status === 'MCFM'
                                    || t_PO_DETAIL.status === 'MCOM'
                                    || t_PO_DETAIL.status === 'BPRO'
                                    || t_PO_DETAIL.status === 'BCOM'
                                    || t_PO_DETAIL.status === 'BPCO'
                                    || t_PO_DETAIL.status === 'BINC'
                                    || t_PO_DETAIL.status === 'DELE'
                                    || t_PO_DETAIL.status === 'APPROVE'
                                    || t_PO_DETAIL.status === 'ACCEPT'
                                    || t_PO_DETAIL.status === 'PCOM'
                                    || t_PO_DETAIL.status === 'COMPLETE') === false 
                                && t_HEADER.transaction_no !== null
                                && <div className="col-12 sp-header-button-panel2 justify-content-center" > 
                                  <a className="sp-btn-icon" 
                                        onClick={(event) => { this.handlePrintPreview(event, data,t_PO_DETAIL.po_contract_no,t_HEADER.mom_no,mom_html,t_MR_DETAIL.receipt_url ? t_MR_DETAIL.receipt_url.replace("http://","https://" ): "",t_HEADER.product_type) }} >
                                        <i className="icon btn-print-orange" />
                                        <span className="sp-btn-icon-label4">Print Preview</span>
                                    </a>
                                </div>}
                               
                               

                                {(t_PO_DETAIL.status === 'BCFM' 
                                 || t_PO_DETAIL.status === 'MCFM' 
                                 || t_PO_DETAIL.status === 'MCOM' 
                                 || t_PO_DETAIL.status === 'BPRO' 
                                 || t_PO_DETAIL.status === 'BCOM' 
                                 || t_PO_DETAIL.status === 'BPCO' 
                                 || t_PO_DETAIL.status === 'BINC' 
                                 || t_PO_DETAIL.status === 'PCOM' 
                                 || t_PO_DETAIL.status === 'CRMR' 
                                 || t_PO_DETAIL.status === 'APPROVE' 
                                 || t_PO_DETAIL.status === 'ACCEPT' 
                                 || t_PO_DETAIL.status === 'COMPLETE') &&  <div className="col-12 sp-header-button-panel2 justify-content-center"  >
                                    <a className="sp-btn-icon" 
                                        onClick={(event) => { this.handlePrint(event, data,t_PO_DETAIL.po_contract_no,t_HEADER.mom_no,mom_html) }} >
                                        <i className="icon btn-print-orange" />
                                        <span className="sp-btn-icon-label4">Print</span>
                                    </a>

                                    { !appReadonly && role === "R" && t_HEADER.transaction_no !== null && (t_PO_DETAIL.status === 'BCFM' || t_PO_DETAIL.status === 'ACCEPT') &&
                                    <a className="sp-btn-icon" onClick={() => { this.handleOnOpenDeleteDialog(t_HEADER.transaction_no) }}>
                                        <i className="icon btn-order-delete" />
                                        <span className="sp-btn-icon-label2">Delete MOM</span>
                                    </a>}
                                </div>}
                            </div>
                        </div>
                    )}
                            </div>
                        )}

                    </div>
                </div>
            <DocumentNotApproveModal 
            onChangeSelectedFile = {(selectedFile,file_type) => this.onChangeSelectedFile(selectedFile, file_type)}
            onUploadComplete={(attmentid) => this.onUploadComplete(attmentid)}
            onUploadCancel={(attmentid) => this.onUploadCancel(attmentid)}
            >

            </DocumentNotApproveModal>
                <POHistory open={this.state.openPOHistory} transactionNo={transaction_no} onClose={()=>{this.handleOnClosePOHistory()}}></POHistory>
                { t_PO_DETAIL.transaction_no &&this.state.openDeleteDialog && <MomDetailDeleteMOM transaction_no={t_PO_DETAIL.transaction_no} open={this.state.openDeleteDialog} title={"Delete"} maxWidth="sm" onClose={()=>this.handleOnCloseDeleteDialog()}></MomDetailDeleteMOM> }
                <CustomDialog open={this.state.openPrintFile} title={"Print ใบตรวจรับการจัดซื้อ/จัดจ้าง"} maxWidth="sm"
                onClose={()=>{
                    this.handleOnClosePrintFile(false)
                }}
                >
                    
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} style={{textAlign:'center'}}>
                            <FormControl>
                                <RadioGroup row aria-label="gender" name="row-radio-buttons-group" spacing={2}>
                                <Button color="primary" variant={this.state.hasPrintHeader ? "contained" :"outlined"} style={{marginRight:5}}><FormControlLabel value="header" style={{marginBottom:0}} control={<Radio style={{color: this.state.hasPrintHeader ? '#ffffff' : '#3f51b5'}} checked={this.state.hasPrintHeader}
                                    onChange={()=>{this.setHasPrintHeader(true)}}
                                    />} label="แบบมี Header/Footer" /></Button>
                                <Button color="primary" variant={!this.state.hasPrintHeader ? "contained" :"outlined"}><FormControlLabel value="noneheader" style={{marginBottom:0}} control={<Radio  style={{color: !this.state.hasPrintHeader ? '#ffffff' : '#3f51b5'}} checked={!this.state.hasPrintHeader}
                                    onChange={()=>{this.setHasPrintHeader(false)}}
                                    />} label="แบบไม่มี Header/Footer" /></Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                        <Grid item xs={12}>
                            <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{this.handleConfirmPrint(t_MR_DETAIL.receipt_url ? t_MR_DETAIL.receipt_url.replace("http://","https://" ): "",t_PO_DETAIL.po_contract_no, t_HEADER.mom_no,t_HEADER.product_type)}}>
                                <i className="icon btn-order-check-green" />
                                <span className="sp-btn-icon-label">ยืนยัน</span>
                            </a>
                        </Grid>
                    </Grid>
                </CustomDialog>
            </div>

        )
    }
}

const mapStateToProps = state => {
    const { MainRedux,UploadRedux } = state
    return {
        viewMode : MainRedux.viewMode,
        transaction_no: MainRedux.transaction_no,
        temp_trans_att_no: MainRedux.temp_trans_att_no,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_PO_COMMITTEE: MainRedux.t_PO_COMMITTEE,
        t_MR_DETAIL: MainRedux.t_MR_DETAIL,
        t_HEADER: MainRedux.t_HEADER,
        t_MR_ATTACHMENTS : MainRedux.t_MR_ATTACHMENTS,
        upload_files: UploadRedux.upload_files,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction)),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        setKeyValue: (table, empCode, empName) => dispatch(setKeyValueAction(table, empCode, empName)),
        updateMR_Detail: (data, fieldName) => dispatch(updateMR_DetailAction(data, fieldName)),
        //updateMR_Attachment :(data,fieldName) => dispatch(updateMR_AttachmentAction(data,fieldName)),
        clearModal: () => dispatch(clearModalAction()),  
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
        getFile: (transactionNo) => dispatch(getFileAction(transactionNo)),
        getSearchDirectoryInfo:(employeeCode,employeeName, positionName, positionABBR ,secondmentFlag, departmentCode, departmentName, departmentABBR, offset,limit) => dispatch(getSearchDirectoryInfoAction(employeeCode,employeeName, positionName, positionABBR ,secondmentFlag, departmentCode, departmentName, departmentABBR, offset,limit)),
        deleteFile: (transactionNo, fileNo, updateBy) => dispatch(deleteFileAction(transactionNo, fileNo, updateBy)),

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MomDetail)